export default __webpack_public_path__ + "static/media/Camilla 9781408352465.b65e4e8a.jpg";